import { useState } from "react";
import { Link } from "react-router-dom";

import JobStatus from "../../components/JobStatus";

import langIco from "../../assets/lang-icon.svg";
import employmentIco from "../../assets/employment-type-icon.svg";
import preferenceIco from "../../assets/preference-icon.svg";
import salaryIco from "../../assets/salary-icon.svg";
import salaryArrow from "../../assets/salary-arrow.svg";

export default function JobsCard({ jobs }) {
  console.log("all jobs", jobs);
  return (
    <>
      <div className="job-card-parent-wrapper">
        {jobs.length !== 0 ? (
          jobs?.map((job) => (
            <div className="job-card-single" key={job.id}>
              <div className="job-card-single__all">
                <div className="row-essy items-center-essy">
                  <div className="col-essy-lg-6 col-essy-md-6">
                    <div className="job-cart-header">
                      <span>Job Name</span>
                      <h4>{job.title}</h4>
                    </div>
                  </div>
                  <div className="col-essy-lg-6 col-essy-md-6">
                    <JobStatus status={job.status} />
                  </div>
                </div>
              </div>

              <div className="job-card-single__position job-card-single__all">
                <span>Position</span>
                <p>{job.position}</p>
              </div>
              <div className="job-card-single__skills job-card-single__all">
                <span>Skills</span>
                <div className="job-card-single__skills--wrapper">
                  {job.skills.map((currSkill) => (
                    <p key={currSkill.id}>{currSkill.name}</p>
                  ))}
                </div>
              </div>
              <div className="job-card-single__info job-card-single__all">
                <div className="job-card-single__info--single">
                  <div className="job-card-single__info--single--icon">
                    <img src={langIco} alt="lang" />
                  </div>
                  <div className="job-card-single__info--single--text">
                    <span>Required Languages</span>
                    <p>{job.languages}</p>
                  </div>
                </div>
                <div className="separator"></div>
                <div className="job-card-single__info--single">
                  <div className="job-card-single__info--single--icon">
                    <img src={employmentIco} alt="employment" />
                  </div>
                  <div className="job-card-single__info--single--text">
                    <p>{job.employment_type}</p>
                  </div>
                </div>
                <div className="separator"></div>
                <div className="job-card-single__info--single">
                  <div className="job-card-single__info--single--icon">
                    <img src={preferenceIco} alt="preferene" />
                  </div>
                  <div className="job-card-single__info--single--text">
                    {job.preferences.map((curr) => (
                      <p key={curr.id}>{curr.name}</p>
                    ))}
                  </div>
                </div>
                <div className="separator"></div>
                <div className="salary-single-wrapper">
                  <div className="job-card-single__info--single">
                    <div className="job-card-single__info--single--icon">
                      <img src={salaryIco} alt="salary" />
                    </div>
                    <div className="job-card-single__info--single--text">
                      <span>Min Salary</span>
                      <p>${job.min_salary}</p>
                    </div>
                  </div>
                  <div className="job-card-single__info--single">
                    <div className="job-card-single__info--single--icon">
                      <img src={salaryArrow} alt="salary" />
                    </div>
                    <div className="job-card-single__info--single--text">
                      <span>Max Salary</span>
                      <p>${job.minimum_bonus}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="description-wrapper job-card-single__all">
                <span>Destripction</span>
                <p>{job.description}</p>
              </div>
              <div className="view-candidates-wrapper">
                <Link
                  className="btn-all-white"
                  to={`/my-jobs/${job.id}/candidates`}
                >
                  View Candidates
                </Link>
              </div>
            </div>
          ))
        ) : (
          <div className="no-jobs-wrapper">
            <h2>
              You Don’t have any jobs yet Schedule a meeting for a new job
            </h2>
          </div>
        )}
      </div>
    </>
  );
}
